import React from 'react';
import { Button } from 'antd';
import { CloseCircleFilled } from '@ant-design/icons';
import { parseMarkdownLinks } from '../../helpers/markdownParser';

interface CodeInvalidStepProps {
  couponCode: string;
  message?: string;
  onTryAgain: () => void;
  onClearCode?: () => void;
  resellerName?: string;
  resellerLogoUrl?: string;
}

const CodeInvalidStep: React.FC<CodeInvalidStepProps> = ({
  couponCode,
  message,
  onTryAgain,
  onClearCode,
  resellerName,
  resellerLogoUrl
}) => {
  return (
    <div className="activation-step">
      <div className="activation-step__content">



        <div className="code-display code-display--invalid code-display--compact" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <span className="code-display__code" style={{ color: '#3f3f3f', textDecoration: 'none' }}>{couponCode}</span>
          <CloseCircleFilled 
            className="code-display__icon code-display__icon--invalid" 
            style={{ color: 'red', cursor: 'pointer' }}
            onClick={onClearCode}
          />
        </div>

        <Button
          type="primary"
          size="large"
          onClick={onTryAgain}
          className="activation-submit-btn"
        >
          Try Again
        </Button>

        <p className="activation-step__subtitle" style={{ paddingTop: '20px', textAlign: 'left' }}>
          {parseMarkdownLinks(message || 'That is either an invalid code or has already been activated.')}
        </p>
      </div>
    </div>
  );
};

export default CodeInvalidStep;
